import { readSupabaseEnv, SUPABASE_ENV_NAMES, type Database } from '@antoja/shared';
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { createSupabaseApi, type ConsoleApi } from './api';

export type AntojaClient = SupabaseClient<Database>;

/** What the screens need to know about the connection, without touching env vars. */
export type Connection =
  | { readonly status: 'ready'; readonly api: ConsoleApi }
  | {
      readonly status: 'unconfigured';
      readonly missing: readonly string[];
      readonly invalid: readonly string[];
    };

/**
 * Builds the connection from VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY.
 * Missing or malformed values never throw: the console shows what to fix.
 */
export function createConnection(env: {
  readonly VITE_SUPABASE_URL?: string | undefined;
  readonly VITE_SUPABASE_ANON_KEY?: string | undefined;
}): Connection {
  const result = readSupabaseEnv(
    { url: env.VITE_SUPABASE_URL, anonKey: env.VITE_SUPABASE_ANON_KEY },
    SUPABASE_ENV_NAMES.console,
  );
  if (!result.ok) {
    return { status: 'unconfigured', missing: result.missing, invalid: result.invalid };
  }
  const client: AntojaClient = createClient<Database>(result.config.url, result.config.anonKey, {
    auth: { flowType: 'pkce', detectSessionInUrl: true, persistSession: true },
  });
  return { status: 'ready', api: createSupabaseApi(client) };
}
